import React from 'react';
import { AlertCircle, Mail } from 'lucide-react';

export default function ActivationRequiredPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="flex justify-center">
            <AlertCircle className="w-16 h-16 text-orange-500" />
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Activation Required
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Your account needs to be activated to continue
          </p>
        </div>
        
        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex items-center space-x-3 mb-4">
            <Mail className="w-5 h-5 text-blue-500" />
            <h3 className="text-lg font-medium text-gray-900">
              Check Your Email
            </h3>
          </div>
          
          <p className="text-gray-600 mb-6">
            We've sent an activation link to your email address. Please check your inbox and click the activation link to continue.
          </p>
          
          <div className="space-y-3">
            <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors">
              Resend Activation Email
            </button>
            
            <button className="w-full bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 px-4 rounded-md transition-colors">
              Back to Login
            </button>
          </div>
        </div>
        
        <div className="text-center">
          <p className="text-xs text-gray-500">
            Need help? Contact our support team
          </p>
        </div>
      </div>
    </div>
  );
}